import React from "react"
import styled from "@emotion/styled"
import InstaIcon from "components/_ui/InstaIcon"

const FooterContainer = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: space-between;
  align-items: center;

  padding-bottom: 40px;
  padding-top: 40px;
  border-top: 2px solid;

  a {
    text-decoration: none;
    color: black;
  }

  a:visited {
    color: black;
  }

  a:hover {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    padding: 40px 0;
    margin: 0 32px;

    & .instaLabel {
      display: none;
    }
  }
`

const FooterSocialWrapper = styled("div")`
  color: currentColor;
  text-decoration: none;
  font-weight: 500;
  letter-spacing: 0.03em;
  font-size: 1em;
  text-transform: uppercase;
  line-height: 120%;

  svg {
    position: relative;
    bottom: -4px;
    width: 24px;
    margin-left: 16px;
  }

  @media (max-width: 768px) {
    font-size: 0.9em;
  }
`

const FooterCreditsWrapper = styled("div")`
  font-size: 0.7em;

  @media (max-width: 768px) {
    width: 100%;
  }
`

const Footer = () => (
  <FooterContainer>
    <FooterCreditsWrapper>Copyright © 2020 Johannes Schön</FooterCreditsWrapper>
    <a
      href="https://www.instagram.com/johannesschoen/"
      target="_blank"
      rel="noreferrer"
    >
      <FooterSocialWrapper>
        <span className="instaLabel">Instagram</span>
        <InstaIcon />
      </FooterSocialWrapper>
    </a>
  </FooterContainer>
)

export default Footer
